import { useEffect, useState } from "react";
import api from "../services/api";

export default function NotificationsPage() {
  const [titre,    setTitre]    = useState("");
  const [message,  setMessage]  = useState("");
  const [cible,    setCible]    = useState("tous");
  const [sending,  setSending]  = useState(false);
  const [result,   setResult]   = useState(null);
  const [historique, setHistorique] = useState([]);

  useEffect(() => {
    api.get("/admin/notifications").then(res => setHistorique(res.data));
  }, []);

  const send = async () => {
    if (!titre.trim() || !message.trim()) {
      alert("Remplis le titre et le message");
      return;
    }
    setSending(true);
    setResult(null);
    try {
      const res = await api.post("/admin/notify", { titre, message, cible 
});
      setResult(res.data);
      setTitre("");
      setMessage("");
      // Recharger historique
      const hist = await api.get("/admin/notifications");
      setHistorique(hist.data);
    } catch (err) {
      setResult({ error: "Erreur envoi" });
    }
    setSending(false);
  };

  const cibleLabel = { tous: "Tous", chauffeurs: "Chauffeurs", clients: 
"Clients" };

  return (
    <div style={{ padding: "1.5rem 0" }}>

      <div style={{ display: "flex", alignItems: "center", justifyContent: 
"space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" 
}}>🔔 Notifications</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Envoyer 
des notifications push</p>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 
20 }}>

        {/* Formulaire */}
        <div style={{ background: "#fff", borderRadius: 12, padding: 24, 
border: "0.5px solid #e5e5e5" }}>
          <p style={{ fontSize: 15, fontWeight: 600, color: "#0B3C5D", 
marginBottom: 20 }}>
            Nouvelle notification
          </p>

          {/* Cible */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, color: "#888", display: "block", 
marginBottom: 8 }}>
              Destinataires
            </label>
            <div style={{ display: "flex", gap: 8 }}>
              {["tous", "chauffeurs", "clients"].map(c => (
                <button key={c} onClick={() => setCible(c)} style={{
                  padding: "8px 16px", borderRadius: 20, cursor: 
"pointer",
                  fontSize: 13, border: "0.5px solid #ccc",
                  background: cible === c ? "#0B3C5D" : "#fff",
                  color: cible === c ? "#fff" : "#888",
                }}>
                  {cibleLabel[c]}
                </button>
              ))}
            </div>
          </div>

          {/* Titre */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, color: "#888", display: "block", 
marginBottom: 6 }}>
              Titre
            </label>
            <input
              value={titre}
              onChange={e => setTitre(e.target.value)}
              placeholder="Ex: Promo weekend 🎉"
              style={{
                width: "100%", padding: "10px 14px", borderRadius: 8,
                border: "0.5px solid #ddd", fontSize: 14, color: 
"#0B3C5D",
                outline: "none",
              }}
            />
          </div>

          {/* Message */}
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 13, color: "#888", display: "block", 
marginBottom: 6 }}>
              Message
            </label>
            <textarea
              value={message}
              onChange={e => setMessage(e.target.value)}
              placeholder="Votre message..."
              rows={4}
              style={{
                width: "100%", padding: "10px 14px", borderRadius: 8,
                border: "0.5px solid #ddd", fontSize: 14, color: 
"#0B3C5D",
                outline: "none", resize: "vertical", fontFamily: 
"inherit",
              }}
            />
          </div>

          {/* Aperçu */}
          {(titre || message) && (
            <div style={{
              background: "#f7f7f7", borderRadius: 10, padding: 14,
              marginBottom: 16, borderLeft: "3px solid #FFA500",
            }}>
              <div style={{ fontSize: 12, color: "#888", marginBottom: 6 
}}>Aperçu notification</div>
              <div style={{ fontSize: 14, fontWeight: 600, color: 
"#0B3C5D" }}>
                {titre || "Titre..."}
              </div>
              <div style={{ fontSize: 13, color: "#555", marginTop: 4 }}>
                {message || "Message..."}
              </div>
            </div>
          )}

          {/* Résultat */}
          {result && (
            <div style={{
              padding: 12, borderRadius: 8, marginBottom: 16,
              background: result.error ? "#FCEBEB" : "#EAF3DE",
              color: result.error ? "#A32D2D" : "#3B6D11",
              fontSize: 13,
            }}>
              {result.error
                ? `❌ ${result.error}`
                : `✅ Envoyé à ${result.sent}/${result.total} 
utilisateurs`}
            </div>
          )}

          {/* Bouton */}
          <button onClick={send} disabled={sending} style={{
            width: "100%", padding: 12, borderRadius: 8, border: "none",
            background: sending ? "#ccc" : "#0B3C5D",
            color: "#fff", fontSize: 14, cursor: sending ? "default" : 
"pointer",
            fontWeight: 500,
          }}>
            {sending ? "Envoi en cours..." : "🔔 Envoyer la notification"}
          </button>
        </div>

        {/* Historique */}
        <div style={{ background: "#fff", borderRadius: 12, padding: 24, 
border: "0.5px solid #e5e5e5" }}>
          <p style={{ fontSize: 15, fontWeight: 600, color: "#0B3C5D", 
marginBottom: 20 }}>
            Historique
          </p>

          {historique.length === 0 && (
            <p style={{ color: "#aaa", fontSize: 14 }}>Aucune notification 
envoyée</p>
          )}

          {historique.map(n => (
            <div key={n.id} style={{
              borderBottom: "0.5px solid #f0f0f0",
              paddingBottom: 12, marginBottom: 12,
            }}>
              <div style={{ display: "flex", justifyContent: 
"space-between", marginBottom: 4 }}>
                <span style={{ fontSize: 14, fontWeight: 500, color: 
"#0B3C5D" }}>{n.titre}</span>
                <span style={{
                  fontSize: 11, padding: "2px 8px", borderRadius: 20,
                  background: "#E6F1FB", color: "#185FA5",
                }}>
                  {cibleLabel[n.cible] ?? n.cible}
                </span>
              </div>
              <p style={{ fontSize: 13, color: "#555", marginBottom: 6 
}}>{n.message}</p>
              <div style={{ display: "flex", justifyContent: 
"space-between" }}>
                <span style={{ fontSize: 11, color: "#aaa" }}>
                  {new Date(n.created_at).toLocaleString("fr-FR")}
                </span>
                <span style={{ fontSize: 11, color: "#3B6D11" }}>
                  ✅ {n.nb_envoyes} envoyés
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
